import { Directive, Input } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzInputDirective } from "ng-zorro-antd/input";
import { UiSizeLDSType } from "@webapp/ui/core/models/ui-size.models";

@Directive({
  selector: "input[ui-input],textarea[ui-input]",
  exportAs: "uiInput",
})
export class UiInputDirective extends NzInputDirective {
  @Input("uiBorderless") @InputBoolean() public nzBorderless = false;
  @Input("uiSize") public nzSize: UiSizeLDSType = "default";
  @Input("disabled")
  set disabled(value: boolean) {
    super.disabled = value;
  }
}
